<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     账单列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-bill mb-md">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <el-date-picker
            v-model="listQuery.period"
            type="month"
            value-format="yyyy-MM"
            placeholder="账期"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item" style="width: 240px">
          <el-input v-model="listQuery.keyword" placeholder="订单号" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        style="width: 100%">
        <el-table-column label="账期" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.period }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账单类型" min-width="140">
          <template slot-scope="scope">
            <span class="font-2x middle"><i class="iconfont icon-month" role="button"></i></span>
            <span class="span">{{ $store.getters.billTypeObj[scope.row.bill_type] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费金额" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.money_total | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="已付金额" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.money_payed | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算状态" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">已结清</span>
            <div v-else class="text-danger">
              <span>未结清</span>
              <span class="span">（请您于 {{ scope.row.deadline | parseTime('{y}/{m}/{d}') }} 前清款）</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="viewBill(scope.row)">查看</el-button>
            <el-button v-if="!scope.row.status" size="mini" type="success" @click="conformBill(scope.row)">付款</el-button>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="listQuery.pindex" :psize.sync="listQuery.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getBillListApi, confirmBillApi } from '@/api/expense/expenseBillApi'
export default {
  name: 'ExpenseBill',
  components: {
  },
  data() {
    return {
      loading: false,
      listQuery: {
        period: null,
        keyword: '',
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      list: []
    }
  },
  computed: {
  },
  created() {
    const keepAlivePath = [
      '/expense/bill/detail'
    ]
    this.listQuery = this.$utils.initListQuery(this.listQuery, keepAlivePath)
    this.fetchData()
  },
  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.listQuery)
    next()
  },
  methods: {
    fetchData(page) {
      if (page) this.listQuery.pindex = page
      this.loading = true
      getBillListApi(this.listQuery).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
          // 超过截止日期，提示付款
        }
      })
    },
    downloadBill(row) {
      //
    },
    viewBill(row) {
      this.$router.push('/expense/bill/detail?billid=' + row.billid)
    },
    conformBill(row) {
      confirmBillApi({ billid: row.billid }).then(res => {
        if (!res.errno) {
          this.viewBill(row)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
